import { Content, ContentQuoteFields } from '@beat-venues/common-types';

export const mockContentQuoteBase: Content<'contentQuote', ContentQuoteFields> =
    {
        sys: {
            id: 'mockContentQuote',
            contentType: {
                sys: {
                    id: 'contentQuote',
                },
            },
        },
        fields: {
            layout: 'Embed',
            quote: 'Quote',
        },
    };

export const mockContentQuoteWithAuthor = {
    ...mockContentQuoteBase,
    fields: {
        ...mockContentQuoteBase.fields,
        quotedPerson: 'John Doe',
    },
};
